<template>
  <div v-if="jackpots && jackpots.length" class="jackpot" :style="gradient">
    <div class="jackpot__logo">
      <img class="" src="../../assets/jackpot/jackpot-logo.webp" alt="jackpot" />
    </div>
    <div class="jackpot__wrapper">
      <div v-if="mediaQueries.desktop" class="jackpot__wrapper-desktop">
        <div class="jackpot__wrapper-desktop-left">
          <jackpot-levels v-if="levels.length" :levels="levels" />
        </div>
        <div class="jackpot__wrapper-desktop-right">
          <jackpot-manufacturers
            v-if="manufacturers.length"
            :manufacturers="manufacturers"
            :active="activeJackpot"
            @change="(value) => (activeJackpot = value)"
          />
          <jackpot-games v-if="games.length" :games="games" @click="goToLink(activeManufacturerId)" />
        </div>
      </div>
      <div v-else class="jackpot__wrapper-mobile">
        <jackpot-manufacturers
          v-if="manufacturers.length"
          :manufacturers="manufacturers"
          :active="activeJackpot"
          @change="(value) => (activeJackpot = value)"
        />
        <jackpot-levels v-if="levels.length" :levels="levels" />
        <jackpot-games v-if="games.length" :games="games" @click="goToLink(activeManufacturerId)" />
        <ol-button
          class="jackpot__wrapper-button"
          :label="t('Подробнее')"
          @click.stop="goToLink(activeManufacturerId)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import getJackpots from 'src/apollo/queries/getJackpots.gql'
import JackpotManufacturers from 'components/jackpot/JackpotManufacturers.vue'
import JackpotLevels from 'components/jackpot/JackpotLevels.vue'
import JackpotGames from 'components/jackpot/JackpotGames.vue'
import { OlButton } from '@gamesite/olimp-core'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const jackpots = ref()
const activeJackpot = ref(0)

const { t } = useI18n()

const router = useRouter()
const gradient = computed(() => {
  let colorFrom
  if (jackpots.value[activeJackpot.value] && jackpots.value[activeJackpot.value]?.propsContent[0]?.props) {
    colorFrom = JSON.parse(jackpots.value[activeJackpot.value]?.propsContent[0]?.props)?.gradient
  }
  if (!colorFrom) {
    return (
      'background: radial-gradient(\n' +
      '    100% 100% at 50% 0%,\n' +
      '    var(--cas-section-gradient-1) 51.5%,\n' +
      '    var(--cas-section-gradient-2) 100%\n' +
      '  );'
    )
  } else {
    return (
      'background: radial-gradient(\n' +
      '    100% 100% at 50% 0%,\n' +
      '    ' +
      colorFrom +
      ' 51.5%,\n' +
      '    var(--cas-section-gradient-2) 100%\n' +
      '  );'
    )
  }
})
const mediaQueries = inject('mediaQueries')

const manufacturers = computed(() => {
  let sortedJackpots = jackpots.value
  return sortedJackpots?.map((jackpot) => jackpot.manufacturer)
})
const games = computed(() => {
  return jackpots.value[activeJackpot.value]?.games || []
})
const levels = computed(() => {
  return jackpots.value[activeJackpot.value]?.jackpotLevels || []
})

const activeManufacturerId = computed(() => {
  return jackpots.value[activeJackpot.value]?.manufacturer.objId
})

async function getJackpotsData() {
  const { onResult } = useQuery(getJackpots)
  onResult(({ data }) => (jackpots.value = data?.jackpots))
}

getJackpotsData()

function goToLink(id) {
  router.push({ name: 'Jackpot', params: { id: id } }).catch(() => {})
}
</script>

<style lang="scss" scoped>
.jackpot {
  width: calc(100% + 20px);
  margin-left: -10px;
  margin-top: 24px;
  transition: background 0.24s;
  background: radial-gradient(
    100% 100% at 50% 0%,
    var(--cas-section-gradient-1) 51.5%,
    var(--cas-section-gradient-2) 100%
  );
  @include tab {
    margin-left: 0;
    width: 100%;
    border-radius: 8px;
  }
}

.jackpot__wrapper {
  padding: 12px;
  @include tab {
    padding: 12px 16px 16px 16px;
  }
  @include desktop {
    padding: 20px 24px 24px 24px;
    position: relative;
  }

  &-desktop {
    display: flex;
    gap: 24px;

    &-left {
      width: 260px;
    }

    &-right {
      width: calc(100% - 284px);
    }
  }

  &-button {
    margin-top: 12px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.07) !important;
    color: rgba(255, 255, 255, 0.9);
    @include tab {
      display: none;
    }
  }
}

.jackpot__logo {
  height: 32px;
  background: url('../../assets/jackpot/pattern.svg') repeat-x;
  width: 100%;
  margin-top: 12px;
  position: relative;

  img {
    width: 260px;
    height: auto;
    display: block;
    position: absolute;
    top: -28px;
    left: 50%;
    transform: translateX(-50%);
    @include desktop {
      left: 24px;
      transform: none;
    }
  }
}
</style>
